<div class="container">
  <h1>{{ 'case.workgroups.title' | translate | capitalize }}</h1>
  <p matRipple class="back-text" (click)="back()">
    <mat-icon>arrow_back</mat-icon>
    {{ 'general.words.back' | translate | capitalize }}
  </p>
  @if (!this.loading) {
    <div class="content">
      @if (!this.loading) {
        <mat-card class="case-workgroups-card card-primary" appearance="outlined">
          <h2 class="bold">{{ this.case?.title }}</h2>
          @if (this.tasksPresent) {
            <div>
              <p>
                {{ 'case.workgroups.description' | translate | capitalize }}
              </p>
              <app-tree [data]="treeData" [(selected)]="this.selectedItems" maxHeight="calc(100vh - 300px)"></app-tree>
            </div>
          }
          @if (!this.tasksPresent) {
            <p>
              {{ 'case.workgroups.description-no-tasks' | translate | capitalize }}
            </p>
          }
        </mat-card>
      }
      @if (this.tasksPresent) {
        <mat-card appearance="outlined" class="save-card card-primary">
          <div>
            <h1>
              {{ 'case.workgroups.link-students.title' | translate | capitalize }}
            </h1>
            <p>
              {{ 'case.workgroups.link-students.description' | translate | capitalize }}
            </p>
          </div>
          <app-spinner-button
            [config]="btnConfig"
            style="float: right; margin: 4px; margin-left: 10px"
            (onClick)="onSaveClick()"></app-spinner-button>
        </mat-card>
      }
    </div>
  }
  @if (this.loading) {
    <div class="content skeleton-content">
      @if (this.loading) {
        <mat-card appearance="outlined" class="case-workgroups-card card-primary skeleton-line">
          <ngx-skeleton-loader [theme]="{ height: '50px' }" count="1" appearance="line"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{ maxWidth: '300px', margin: '10px', height: '30px' }"
            count="8"
            appearance="line"></ngx-skeleton-loader>
        </mat-card>
      }
      <mat-card class="save-card card-primary" appearance="outlined">
        <ngx-skeleton-loader [theme]="{ height: '50px' }" count="1" appearance="line"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="3" appearance="line"></ngx-skeleton-loader>
      </mat-card>
    </div>
  }
</div>
